export default __webpack_public_path__ + "static/media/WhitePattermSmall.27aa3166.svg";